module.exports = __webpack_public_path__ + "img/female-clerk.e32444c6.png";